(() => {
  function init(root) {
    if (root.dataset.faqReady) return;
    root.dataset.faqReady = 'true';
    const search = root.querySelector('[data-faq-search]');
    const select = root.querySelector('[data-faq-select]');
    const buttons = [...root.querySelectorAll('[data-faq-category]')];
    const items = [...root.querySelectorAll('[data-faq-item]')];
    const index = items.map((item, position) => ({ item, position, label: item.querySelector('.s2t-faq-library__topic-label').textContent, text: normalize(item.querySelector('.s2t-faq-library__question').textContent + ' ' + item.querySelector('.metafield-rich_text_field').textContent) }));
    let category = 'all';
    let timer;
    function normalize(text) { return text.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
    function filter() {
      const terms = normalize(search.value).split(' ').filter(Boolean);
      let count = 0;
      const selected = buttons.find(button => button.dataset.faqCategory === category);
      const ordered = [...index].sort((a, b) => {
        const rank = entry => category === 'all' ? entry.position : Number(entry.item.dataset.faqOrders.split('|').find(pair => pair.startsWith(category + ':'))?.split(':')[1] || 999);
        return rank(a) - rank(b);
      });
      ordered.forEach(({ item, text, label }) => {
        root.querySelector('.s2t-faq-library__list').append(item);
        item.querySelector('.s2t-faq-library__topic-label').textContent = category === 'all' ? label : selected?.textContent || label;
        const show = (category === 'all' || item.dataset.faqGroups.includes(`|${category}|`)) && terms.every(term => text.includes(term));
        item.hidden = !show;
        if (show) count += 1;
      });
      select.value = category;
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.faqCategory === category)));
      root.querySelector('[data-faq-heading]').textContent = selected?.textContent || 'All questions';
      root.querySelector('[data-faq-intro]').textContent = selected?.dataset.faqDescription || 'From your first transfer to your next big project.';
      root.querySelector('[data-faq-count]').textContent = `${count} ${count === 1 ? 'answer' : 'answers'}${search.value.trim() ? ' matching your search' : ''}`;
      root.querySelector('[data-faq-empty]').hidden = count !== 0;
    }
    function readHash(focus = false) {
      let handle;
      try { handle = decodeURIComponent(location.hash.slice(1)); } catch (_) { return; }
      if (!handle) { category = 'all'; search.value = ''; filter(); return; }
      if (handle.startsWith('topic-')) {
        const candidate = handle.slice(6);
        if (buttons.some(button => button.dataset.faqCategory === candidate)) { category = candidate; search.value = ''; filter(); }
        return;
      }
      const item = items.find(entry => entry.id === handle);
      if (!item) return;
      const available = item.dataset.faqGroups.split('|').filter(Boolean);
      if (!available.includes(category)) category = item.id === 'printing-and-shipping' ? 'shipping-orders' : available[0] || 'all';
      search.value = '';
      filter();
      item.open = true;
      requestAnimationFrame(() => {
        if (focus) item.querySelector('summary').focus({ preventScroll: true });
        item.scrollIntoView({ block: 'start', behavior: 'instant' });
      });
    }
    function selectCategory(next) {
      category = next;
      filter();
      history.pushState(null, '', `${location.pathname}${location.search}#topic-${category}`);
    }
    root.querySelectorAll('[data-faq-controls]').forEach(control => { control.hidden = false; });
    root.querySelectorAll('[data-faq-copy]').forEach(control => { control.hidden = false; });
    search.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(filter, 100); });
    select.addEventListener('change', () => selectCategory(select.value));
    buttons.forEach(button => button.addEventListener('click', () => selectCategory(button.dataset.faqCategory)));
    root.querySelectorAll('[data-faq-clear]').forEach(button => button.addEventListener('click', () => { category = 'all'; search.value = ''; clearTimeout(timer); filter(); history.replaceState(null, '', location.pathname + location.search); search.focus(); }));
    root.querySelectorAll('[data-faq-permalink]').forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      const hash = new URL(link.href).hash;
      if (location.hash === hash) readHash(true); else location.hash = hash;
    }));
    root.querySelectorAll('[data-faq-copy]').forEach(button => button.addEventListener('click', async () => {
      const item = button.closest('[data-faq-item]');
      const link = item.querySelector('[data-faq-permalink]');
      const status = item.querySelector('[data-faq-copy-status]');
      try { await navigator.clipboard.writeText(link.href); status.textContent = 'Link copied.'; }
      catch (_) { status.textContent = 'Use “Link to this answer” to open the answer, then copy its address.'; }
    }));
    window.addEventListener('hashchange', () => readHash(true));
    window.addEventListener('popstate', () => readHash(true));
    filter();
    readHash();
  }
  document.querySelectorAll('[data-s2t-faq-library]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-s2t-faq-library]').forEach(init));
})();
